<script setup lang="ts">
import BaseForm from "~/components/ui/BaseForm.vue";
import ProgressBar from "~/components/ui/ProgressBar.vue";
import FormCard from "~/components/ui/FormCard.vue";
import BackButton from "~/components/inputs/BackButton.vue";
import Select from "~/components/inputs/Select.vue";
import InputFloatingLabel from "~/components/inputs/InputFloatingLabel.vue";
import personalData2 from "~/rules/personalData2";

import { useVuelidate } from "@vuelidate/core";
import Validator from "~/utils/validator";

defineProps({
  progress: { type: Number, required: true },
  title: { type: String, required: true },
});

const locale = await getLocale("forms", "personal_data2");

const housingType = useState<number | null>("housingType", () => null);
const monthlyRent = useState<string | null>("monthlyRent", () => null);

const emit = defineEmits(["init", "submit", "goBack"]);
const v$ = useVuelidate(personalData2, { housingType, monthlyRent });

watch(housingType, () => {
  if (housingType.value !== 1) {
    monthlyRent.value = null;
  }
  v$.value.$reset();
});

const validate = () => {
  v$.value.$touch();
  v$.value.$validate();
  return !v$.value.$error;
};

const submit = () => {
  if (validate()) {
    emit("submit");
  }
};
onMounted(() => emit("init"));
</script>

<template>
  <BaseForm class="personal-data2-container">
    <template #upper>
      <ProgressBar :value="progress" />
      <FormCard :title="title" @submit="submit">
        <div class="w-full lg:w-1/3 lg:pr-4">
          <small class="text-xs">{{ locale.housing_type }}</small>
          <Select
            v-model="housingType"
            :values="housingTypeOptions"
            :label="locale.housing_type"
            disable-zero-value
            floating
            :error="v$.housingType.$error"
            :error-message="Validator.message(v$.housingType)"
            test-id="housingType"
          />
        </div>
        <div v-if="housingType === 1" class="w-full lg:w-1/3 lg:pr-4">
          <small class="text-xs">{{ locale.monthly_rent }}</small>
          <InputFloatingLabel
            v-model="monthlyRent"
            :label="locale.monthly_rent"
            type="text"
            :mask="currencyMask"
            :error="v$.monthlyRent.$error"
            :error-message="Validator.message(v$.monthlyRent)"
            test-id="monthlyRent"
          />
        </div>

        <template #link>
          <BackButton :event="`goBack`" @go-back="$emit('goBack')" />
        </template>
      </FormCard>
    </template>
  </BaseForm>
</template>

<style scoped></style>
